import { createElementVNode as _createElementVNode, vModelText as _vModelText, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "container-fluid fill-height" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-xl-4 col-lg-4 col-sm-12 col-md-6" }
const _hoisted_4 = { class: "card" }
const _hoisted_5 = { class: "card-content" }
const _hoisted_6 = { class: "form-field__outline--control" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  for: "Industry",
  class: "form-field__outline--control__label"
}, "Industry", -1)
const _hoisted_8 = { class: "form-field form-field__outline form-field__outline--active ma--top-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", {
  for: "credits",
  class: "form-field__outline--control__label"
}, "State", -1)
const _hoisted_10 = {
  key: 0,
  class: "autocomplete",
  style: {"height":"100px","overflow":"auto"}
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "form-field__outline--control" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", {
  for: "zipcode",
  class: "form-field__outline--control__label"
}, "Zipcode", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "card-actions display--flex justify--flex-end" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "submit",
    class: "btn btn--success"
  }, " Request ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_outline = _resolveDirective("outline")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("form", {
            onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.sendRequest && _ctx.sendRequest(...args)), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", {
                class: _normalizeClass(["form-field form-field__outline ma--top-2", { 
                  'form-field__outline--invalid': _ctx.v$.request.industry.$error,
                  'form-field__outline--active': !_ctx.v$.request.industry.$invalid 
                }])
              }, [
                _createElementVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-field__outline--control__input",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.request.industry) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.request.industry],
                    [_directive_outline]
                  ])
                ])
              ], 2),
              _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_8, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-field__outline--control__input",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.request.state) = $event)),
                  readonly: "",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.stateToggle = true))
                }, null, 512), [
                  [_vModelText, _ctx.request.state],
                  [_directive_outline]
                ]),
                _createElementVNode("i", {
                  class: _normalizeClass(["fa form-field__outline--select--arrow", {
                    'fa-sort-down': !_ctx.stateToggle,
                    'fa-sort-up': _ctx.stateToggle
                  }])
                }, null, 2),
                _hoisted_9,
                (_ctx.stateToggle)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.states, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: _normalizeClass(["autocomplete__item", {
                      'autocomplete__item--active': item.stateName == _ctx.request.state
                    }]),
                          key: index,
                          onClick: ($event: any) => {_ctx.request.state = item.stateName; _ctx.stateToggle = false;}
                        }, _toDisplayString(item.stateName), 11, _hoisted_11))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ])), [
                [_directive_click_outside, _ctx.clickOutSideState]
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(["form-field form-field__outline ma--top-2", { 
                  'form-field__outline--invalid': _ctx.v$.request.zipCode.$error,
                  'form-field__outline--active': !_ctx.v$.request.zipCode.$invalid 
                }])
              }, [
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-field__outline--control__input",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.request.zipCode) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.request.zipCode],
                    [_directive_outline]
                  ])
                ])
              ], 2)
            ]),
            _hoisted_14
          ], 32)
        ])
      ])
    ])
  ]))
}